import { RarityJsonldCardFilterData } from '@/api/generated';

export const RARITY_SHADOW_CLASS: Record<RarityJsonldCardFilterData['reference'], string> = {
  COMMON: '',
  RARE: 'shadow-[0_0_16px_0_rgba(3,162,255,0.6)]',
  UNIQUE: 'shadow-[0_0_20px_0_rgba(216,164,30,0.8)]',
};
